<template>
  <v-container class="pa-4 pa-md-10">
    <!-- Container Title -->
    <div class="d-flex flex-column pa-4 pa-md-10">
      <div class="title-large pb-4">
        Configuración de {{ $store.state.sFullName }}
      </div>
      <div class="text-body">
        Administra la seguridad de tu cuenta
      </div>
    </div>

    <!-- Container Options -->
    <div class="pa-4 pa-md-10">
      <!-- Reset password -->
      <div
        class="d-flex align-center row-option"
        :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
      >
        <div class="icon-container mr-md-4 mb-2 mb-md-0">
          <v-icon
            :size="$vuetify.breakpoint.smAndDown ? 32 : 50"
            color="black"
            >mdi-lock</v-icon
          >
        </div>
        <div class="d-flex flex-column px-0 px-md-10 flex-grow-1 w-100">
          <div class="title-medium">Restablecer contraseña</div>
          <div class="text-body-secondary pt-2">
            Para restablecer tu contraseña, necesitas ingresar tu contraseña actual y la nueva contraseña.
          </div>
        </div>
        <div class="button-col mt-2 mt-md-0 w-100 w-md-auto">
          <v-btn
            color="black"
            outlined
            size="small"
            rounded
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            elevation="5"
            min-width="220"
            class="no-uppercase w-100 w-md-auto"
            @click="openModalResetPassword"
          >
            Restablecer contraseña
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <DialogResetPassword
      v-model="showDialogResetPassword"
    />
  </v-container>
</template>

<script>
import DialogResetPassword from "./dialogs/DialogResetPassword.vue";

export default {
  name: "Security",
  components: {
    DialogResetPassword
  },
  data() {
    return {
      showDialogResetPassword: false
    };
  },

  methods: {
    openModalResetPassword() {
      this.showDialogResetPassword = true;
    }
  },
  computed: {
    selectLanguage() {
      return this.$store.state.language;
    }
  }
};
</script>

<style scoped>
.title-large {
  font-family: "montserrat-semibold";
  font-size: 24px;
  font-weight: 600;
  color: black;
}

.text-body {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  color: #737583;
}

.text-body-large {
  font-family: "montserrat-regular";
  font-weight: 400;
  font-size: 10px;
  color: #000000;
}

.title-medium {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: 0%;
  color: #000000;
}

.text-body-secondary {
  font-family: "montserrat-regular";
  font-size: 12px;
  font-weight: 400;
  color: #000000;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  border-radius: 50%;
  background-color: #d9d9d9;
}

.no-uppercase {
  text-transform: none !important;
}

.row-option {
  min-height: 100px;
  align-items: center;
}

.row-option > div:last-child {
  display: flex;
  align-items: center;
  height: 100%;
}

.v-btn {
  height: 48px;
  display: flex;
  align-items: center;
}

.flex-grow-1 {
  flex-grow: 1;
}

.button-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10vh;
  min-width: 220px;
}

@media (max-width: 960px) {
  .pa-md-10 {
    padding: 40px !important;
  }
  .px-md-10 {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
  .py-md-8 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
}

@media (max-width: 600px) {
  .title-large {
    font-size: 18px;
  }
  .title-medium {
    font-size: 14px;
  }
  .text-body,
  .text-body-secondary {
    font-size: 12px;
  }
  .icon-container {
    width: 56px;
    height: 56px;
    min-width: 56px;
    min-height: 56px;
    margin-bottom: 8px;
  }
  .row-option {
    flex-direction: column !important;
    align-items: flex-start !important;
    min-height: unset;
    padding: 16px 0;
  }
  .button-col {
    margin-right: 0;
    min-width: 100%;
    width: 100%;
    justify-content: flex-start;
    margin-top: 12px;
  }
  .pa-4 {
    padding: 16px !important;
  }
  .px-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .w-100 {
    width: 100% !important;
  }
  .w-md-auto {
    width: auto !important;
  }
  .v-dialog__content {
    max-width: 95vw !important;
  }
  .v-card {
    padding: 8px !important;
  }
}
</style>
